import { api_configuration } from "../../../common";
import cs = api_configuration.types.client_state.alan_api;
import messages = require("../../front/messages");
import { getQueryEntryKey } from "../../state/Query";
import { iText } from "../../state/Text";

export default function (candidate: cs.Ccandidates__use_for__entries): void {
	const cs_text = candidate.inferences.use().inferences.reference_property().parent;
	const value = getQueryEntryKey(candidate.parent.properties.entry_status);
	if (value !== undefined) {
		iText(cs_text.parent).update(value, "user");
	} else {
		messages.addMessage("warning", "Cannot select reference", { body: "The key is unknown." });
	}
}
